<div *ngFor="let name of properties()" class="ellipsed">
    <span translate style="font-weight: bold">{{stamp().$t + '.' + name | translate}}:</span> <span>{{stamp().values[name]}}</span>
</div>
<div *ngIf="properties().length == 0">
    <span translate>SagaMobile.NoStampData</span>
</div>
